<app-links-item *ngIf="tag" [color]="tag.color.hexa" [icon]="tag.icon.code" [labels]="tag.labels" [uid]="tag.uid">
  <div app-links-item-content-description>
  </div>
  <div app-links-item-content-option>
    <app-links-item-option class="d-block mx-1" [symbol]="'check'" [selected]="isSelected" (sendSelected)="receiveSelected()"></app-links-item-option>
  </div>
</app-links-item>